import { ApplicationConfig, LOCALE_ID, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { ApiInterceptor } from './api.interceptor';
import { intializeAppFn } from './load-remote-env';
import { provideTranslateService } from '@ngx-translate/core';
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import { NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import { CustomModalService } from './CustomModalService';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';


registerLocaleData(localeIn, 'en-IN');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'en-IN' },
    CurrencyPipe,
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withFetch(),
      withXsrfConfiguration({cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN'}),
      withInterceptors([ApiInterceptor])      
    ),   
    { provide: NgbModal, useClass: CustomModalService }, 
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './i18n/',
        suffix: '.json',        
        useHttpBackend: true
      }),
      fallbackLang: 'en',
      lang: 'hi'      
    }),
    provideAppInitializer(intializeAppFn),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration:'top',        
        anchorScrolling: 'enabled' // enables #anchor scrolling
      }),
      withComponentInputBinding()
    ), 
    provideClientHydration(withEventReplay())  
  ]
};


